var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.showLimitsDialogAfterRegistration,
          expression: "showLimitsDialogAfterRegistration"
        }
      ],
      staticClass: "registration-limits"
    },
    [
      _c(
        "div",
        {
          staticClass: "tandc-popup-container post-reg-limits-popup__container"
        },
        [
          _vm.showLimitsDialogAfterRegistration
            ? _c("div", { staticClass: "tandc-popup-child" }, [
                _c("div", { staticClass: "tc-heading" }, [
                  _vm._v(_vm._s(_vm.$t("Account.Limits")) + "\n        "),
                  _c(
                    "div",
                    {
                      staticClass: "close_icon",
                      on: {
                        click: function($event) {
                          return _vm.closeLimitsDialog()
                        }
                      }
                    },
                    [_c("v-icon", [_vm._v("close")])],
                    1
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "tandc-popup-content" },
                  [_c("Limits", { attrs: { isOnRegistration: true } })],
                  1
                )
              ])
            : _vm._e()
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1efa4ebc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1efa4ebc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/account/Limits/PostRegistrationLimitsV2.vue
// module id = null
// module chunks = 